'use strict';

function resizeWindow() {
	var allcont = $(window).width() - 230;
	//$('.all_block').css('width', allcont + 'px');
	$('#home .top-content').css('width', allcont + 'px');
	$('#home .top-content .header-img').css('width', allcont + 'px');
	$('#myGallery').css('width', allcont + 'px');

	var headerW = $(window).width() - 230;
	$('#home .top-content').css('width', headerW + 'px');
	$('#home .home-gallery, .home-gallery').css('width', headerW + 'px');

	$('#home .home-gallery a, .home-gallery a').height($('#home .home-gallery a').width());
}
function scrollDown() {
	var top = $(document).scrollTop();

	//alert
	if ($('.topalert').length > 0) {
		setTimeout(function () {
			$('.booking_block').addClass('withalert');
		}, 600);
	}

	if (top > 0) {
		if ($('body#home').length > 0) {
			if (top > 670) {
				showReasons();
			}
			if (top > 2760) {
				showHomeEvent();
			}
			if (top > 1830) {
				showHomeSpecial();
			}
			if (top > 2375) {
				showHomeBlog();
			}
		}
		if ($('.booking_block').hasClass('withalert')) {
			$('.booking_block').removeClass('withalert');
		}
	} else {
		if ($('.booking_block').hasClass('withalert')) {
			$('.booking_block').addClass('withalert');
		}
	}
}

function showHomeSpecial() {
	$('#home .bottom .home-features .home-special').addClass('show');
}
function showHomeBlog() {
	$('#home .bottom .home-features .home-blog').addClass('show');
}

function showReasons() {
	$('#home .main-content .home-reasons .reason').addClass('show');
}

function showHomeEvent() {
	if (!$('#home .bottom .home-events .container .event#events').hasClass('active')) {
		$('#home .bottom .home-events .container .event#weddings').fadeIn(500, function () {
			$(this).addClass('active');
		});
	}
}

$(document).ready(function () {

	$('.share-btn').hide();
	//Call function with browser is resized.
	$(window).resize(function (event) {
		resizeWindow();
	});
	resizeWindow();
	scrollDown();
	//Acts when scroll down page.
	$(window).scroll(function (event) {
		scrollDown();
		hideBooking();
	});

	var selectSpecialDiscount = document.getElementById('selectSpecialDiscount');
	if (selectSpecialDiscount) {
		selectSpecialDiscount.onchange = function (e) {
			var buttonOffer = $('#deal7180 .btn');
			buttonOffer[0].href = e.target.value;
		};
	}

	//Add mising Placeholder
	$("#panel .startdir").each(function () {
		var label__val = $(this).find("label").text();
		$(this).find("input, textarea").prop("placeholder", label__val);
	});

	$('#mode').prepend('<option value="Travel Mode" selected="selected" disabled>Travel Mode</option>');

	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function (event) {
		$('body, html').animate({ scrollTop: $('#home .top-content').height() }, 1200, 'easeOutExpo');
	});

	//Slick Slider
	$('.sym-slides').slick();
	$('#home .home-reasons').slick({
		arrows: false,
		dots: true,
		fade: true,
		cssEase: 'linear',
		accessibility: true
	});

	$('#home .main-content .home-testimonials .testimonials').slick({
		arrows: false,
		dots: true,
		fade: true,
		cssEase: 'linear',
		accessibility: false
	});

	//Event Tracking
	$('.book-now').on('click', function () {
		ga('send', 'event', 'reservations', 'click', 'book now');
	});
	$('.bookNow').on('click', function () {
		ga('send', 'event', 'header widget', 'click', 'book now');
	});

	// $('.booking_btn').click(function(){
	//  $('.booking_block').slideDown(500);
	// });

	// $('.booking_btn-header').click(function(){
	//  $('.booking_block-header').slideDown(500);
	// });

	//Check in and check out datepicker for booking engine
	$("#CheckIn, #CheckIn-header").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function onSelect(selectedDate) {
			var getDate = $(this).datepicker('getDate');
			var newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#CheckOut, #CheckOut-header").datepicker("setDate", newDate);
			$("#CheckOut, #CheckOut-header").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#CheckOut, #CheckOut-header").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function onSelect(selectedDate) {
			$("#CheckIn, #CheckIn-header").datepicker("option", "maxDate", selectedDate);
		}
	});

	//home map
	$('#home .bottom .home-map .wrapper .pins .pin').click(function () {
		var current = $(this).attr('id');
		$('#home .bottom .home-map .wrapper .pins .pin').removeClass('active');
		$(this).addClass('active');
		$('#home .bottom .home-map .wrapper .info .pin').removeClass('active');
		$('#home .bottom .home-map .wrapper .info .pin.' + current).addClass('active');
	});

	//home events toggle
	$('#home .bottom .home-events .container .controls ul li').click(function () {
		var current = $(this).find('span').html().toLowerCase();
		$('#home .bottom .home-events .container .controls ul li').removeClass('active');
		$(this).addClass('active');
		$('#home .bottom .home-events .container .event').fadeOut(200, function () {
			$(this).removeClass('active');
		});
		$('#home .bottom .home-events .container .event#' + current).fadeIn(500, function () {
			$(this).addClass('active');
		});
	});

	//Map prev button addition
	if ($('body#map').length > 0) {
		$('body#map #content').append('<a href="javascript:window.history.back()" class="prev">Go to Previous Page</a>');
	}
	//thank you message 
	$('form .btn.btnSubmit').click(function () {
		setTimeout(function () {
			$('p#thankyou').fadeOut(500);
		}, 6000);
	});

	//content sym-inline-list
	$('ul.sym-inline-list li').each(function () {
		$(this).wrapInner('<span></span>');
	});

	//Request button on tablet for events and weddings
	if ($('body.meetings-events').length > 0) {
		$('#content #bottom-content .full-text').append('<a href="' + site_url + 'meetings-events/host-an-event" class="btn request">Request for Proposal</a>');
	}
	if ($('body.kerrville-weddings').length > 0) {
		$('#content #bottom-content .full-text').append('<a href="' + site_url + 'kerrville-weddings/start-planning" class="btn request">Request for Proposal</a>');
	}

	$('ul.accommodations li.room .image').slick({
		arrows: true,
		dots: false,
		fade: true,
		accessibility: false
	});
	//Blog
	$('.posts .posts-list .excerpt-post .readMore').click(showMoreBlog);

	//Events page
	if ($('body.meetings-events').length > 0) {
		$('h2').each(function () {
			if ($(this).html() == 'Event Spaces') {
				$(this).siblings('.two_content').find('.item:first-child').css('border', 'none');
			}
		});
	}

	//Specials accordeaon
	if ($('body.specials').length > 0) {
		$('ul.specials li.deal').each(function () {

			$(this).find('.desc p').each(function () {
				if ($(this).children('em').length > 0) {
					$(this).hide();
					$(this).parent().append('<div class="moreDetails">Read More</div>');

					$('.desc .moreDetails').click(showMoreSpecial);
				}
			});
		});
	}

	$('.live-music').appendTo('.music-content');
});

function hideBooking() {
	//$('.booking_block, .booking_block-header').slideUp(500);
}

function showMoreBlog() {
	$(this).parent().find('p').fadeOut(10);
	$(this).parent().find('.allpost').slideDown(600);
	$(this).html('Read Less');
	$(this).unbind('click');
	$(this).click(hideMoreBlog);
	$('.share-btn').slideDown(600);
}
function hideMoreBlog() {
	$(this).parent().find('.allpost').fadeOut(10);
	$(this).parent().find('p').slideDown(200);
	$(this).html('Read More');
	$(this).unbind('click');
	$('.share-btn').hide();
	$(this).click(showMoreBlog);
}

function showMoreSpecial() {
	$(this).parent().find('p').fadeIn();
	$(this).html('Read Less');
	$(this).unbind('click');
	$(this).click(hideMoreSpecial);
}
function hideMoreSpecial() {

	$(this).parent().find('p').each(function () {
		if ($(this).children('em').length > 0) {
			$(this).fadeOut();
		}
	});
	$(this).html('Read More');
	$(this).unbind('click');
	$(this).click(showMoreSpecial);
}

$(window).load(function () {
	$('.sym-slides').slick();
});